export async function waitForAtLeast(minDuration, promise) {
  const results = await Promise.all([promise, timeout(minDuration)]);
  return results[0];
}

async function timeout(ms) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
}

export function hide(element) {
  element.classList.add("d-none");
}

export function unhide(element) {
  element.classList.remove("d-none");
}

export function getElementPaddings(element) {
  const style = window.getComputedStyle(element);
  return {
    top: parseInt(style.paddingTop, 10),
    bottom: parseInt(style.paddingBottom, 10),
    left: parseInt(style.paddingLeft, 10),
    right: parseInt(style.paddingRight, 10),
  };
}

export function getElementMargins(element) {
  const style = window.getComputedStyle(element);
  return {
    top: parseInt(style.marginTop, 10),
    bottom: parseInt(style.marginBottom, 10),
    left: parseInt(style.marginLeft, 10),
    right: parseInt(style.marginRight, 10),
  };
}

export function watchScroll(viewAreaElement, callback, debounceTimeout = 300) {
  let timer;

  function debounceScroll() {
    if (timer) {
      return;
    }
    timer = setTimeout(function () {
      callback({
        scrollTop: viewAreaElement.scrollTop,
        scrollLeft: viewAreaElement.scrollLeft,
      });
      timer = null;
    }, debounceTimeout);
  }

  viewAreaElement.addEventListener("scroll", debounceScroll, true);

  return {
    destroy: function () {
      viewAreaElement.removeEventListener("scroll", debounceScroll, true);
    },
  };
}

export function watchScreenResize(callback, debounceTimeout = 500) {
  let timer;

  function debounceResize() {
    if (timer) {
      return;
    }
    timer = setTimeout(function () {
      callback();
      timer = null;
    }, debounceTimeout);
  }

  window.addEventListener("resize", debounceResize, true);

  return {
    destroy: function () {
      console.log("removing handler");
      window.removeEventListener("resize", debounceResize, true);
    },
  };
}
